import styled from "styled-components";

export const FormContainer = styled.div`
  width: 45%;

  @media(max-width: 1389px) {
    width: 60%;
  }

  @media(max-width: 1206px) {
    width: 70%;
  }

  @media(max-width: 1050px) {
    width: 80%;
  }

  @media(max-width: 992px) {
    width: 55%;
  }

  @media(max-width: 768px) {
    width: 70%;
  }

  @media(max-width: 640px) {
    width: 85%;
  }

  @media(max-width: 520px) {
    width: 100%;
  }
`

export const TitleParagraph = styled.p`
  font-family: "Suisse International", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #000000;
  margin-bottom: 8px;
`;

export const SubTitleParagraph = styled.p`
  font-family: "Inter";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.32px;
  text-align: center;
  color: #A39D9E;

`;

export const FormBodyDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & > div {
    margin-bottom: 28px;
    max-width: 100%;
  }

`;

export const FormInputDiv = styled.div`
  display: block;
  width: 100%;
  margin: 18px 0 32px;
  font-family: "Inter";
  
  & > span {
    font-weight: 400;
    font-size: 10px;
    line-height: 15.6px;
    margin-top: 4px;
    color: var(--primary-brand);
  }
  @media (min-width: 768px) {
    margin: 18px 0 32px;
  }
`;
